"use client";

import React from "react";
import { useCardGridItemContext } from "./CardGridItemContext";

interface CardGridItemPanelProps {
  children: React.ReactNode;
}

export function CardGridItemPanel({ children }: CardGridItemPanelProps) {
  const { item } = useCardGridItemContext();

  return (
    <div className="rounded-b-box border-base-content/20 bg-base-100 -mt-4 w-full border p-2 pt-2">
      <h3 className="sr-only">{item.name}</h3>
      <div className="flex flex-col gap-0.5 pt-2 lg:pt-3">{children}</div>
    </div>
  );
}
